import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doCreateLocation = createAsyncThunk(
  "locations/doCreateLocation",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doCreateLocation(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);


export const doUpdateLocation = createAsyncThunk(
  "locations/doUpdateLocation",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doUpdateLocation(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doDetailLocation = createAsyncThunk(
  "locations/doDetailLocation",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doDetailLocation(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doDeleteLocation = createAsyncThunk(
  "locations/doDeleteLocation",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doDeleteLocation(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);
